
export const csrf = (document.querySelector("meta[name='csrf-token']") == undefined) ? "" : document.querySelector("meta[name='csrf-token']").getAttribute("content")
export const headers = {
	   'Content-Type': 'application/json',
	   'X-CSRF-Token': csrf
 	}
